import { create } from "zustand";

import { AllocateFundsStore, AllocateFundsStoreProps } from "@ctypes";

export const useAllocateFundsStore = create<AllocateFundsStore>((set) => ({
  allocateFundsProps: {},
  setAllocateFundsProps: (allocateFundsProps: AllocateFundsStoreProps) =>
    set(() => ({ allocateFundsProps })),
}));
